import $ from "jquery";
import AnalyticsTracker from "./analytics";

require('./jquery.validate');

const analytics = new AnalyticsTracker();

/** ----------------------------------------
 Jquery form validation
 ---------------------------------------- */


/** ----------------------------------------
 Default options
 ---------------------------------------- */


function unhighlight(element) {
    const ele = $(element);
    const master = ele.closest('.input-section');
    const parent = ele.closest('.input-group');
    parent.removeClass('has-error');

    if (master.find('.has-error').length === 0) {
        ele.closest('.input-section').removeClass('is-invalid').addClass('is-valid');
    }
}


function highlight(element) {
    const ele = $(element);
    const parent = ele.closest('.input-group');
    ele.closest('.input-section').addClass('is-invalid').removeClass('is-valid');
    parent.addClass('has-error');
}

function addErrorMessage(element, error) {
    element.closest('.input-section').find('.error-message').html(error);
}


function requestErrorHandling(res, form) {
    $(form).validate().showErrors(res.responseJSON.errors);
    const key = Object.keys(res.responseJSON.errors)[0];
    const firstInout = $('[name=' + key + ']');
    $('html, body').animate({
        scrollTop: firstInout.offset().top - 400
    }, 1000);
}

function handleInvalid(event, validator) {
    const errors = validator.numberOfInvalids();
    if (errors) {
        const firstInvalidElement = $(validator.errorList[0].element);
        $('html, body').animate({
            scrollTop: firstInvalidElement.offset().top - 100
        }, 500, function() {
            firstInvalidElement.focus();
        });
    }
}


const validation_options = {
    highlight: function (element) {
        highlight(element);
    },
    unhighlight: function (element) {
        unhighlight(element)
    },
    errorPlacement: function (error, element) {
        addErrorMessage(element, error);
    },
    invalidHandler: handleInvalid
};


/** ----------------------------------------
 Overwrite message
 ---------------------------------------- */

/**
 * Make required message empty on default
 */

$.extend($.validator.messages, {
    required: "",
    email: "Geef alstublieft een geldig emailadres op",
});


/** ----------------------------------------
 Add rules
 ---------------------------------------- */

/**
 * Add custom validation rules
 */

$.validator.addMethod("laxEmail", function (value, element) {
    // allow any non-whitespace characters as the host part
    return this.optional(element) || /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value);
}, 'Geef alstublieft een geldig emailadres op');

$.validator.addMethod("zipcode", function (value, element) {
    const refField = element.dataset.selectField;
    const country = $('[name=' + refField + ']').val();

    let regex = /^[1-9]\d{3}\s?(?!SA|SD|SS)[a-zA-Z]{2}$/;
    if (country === 'BE') {
        regex = /^[1-9]\d{3}$/;
    }

    return this.optional(element) || regex.test(value);
}, 'Ongeldige postcode');

$.validator.addMethod('vat', function (value, element) {
    const mod11 = function (val) {
        let numbers = val.substring(2, 11);
        const total = numbers.split('').reduce(function (acc, val, index) {
            if (index === 8) {
                return acc += -1 * parseInt(val);
            }

            return acc += (9 - index) * parseInt(val);

        }, 0);

        return total % 11 === 0;
    };

    // Custom modulo function to deal with large nubmers
    function modulo (divident, divisor) {
        var cDivident = '';
        var cRest = '';

        for (var i in divident ) {
            var cChar = divident[i];
            var cOperator = cRest + '' + cDivident + '' + cChar;

            if ( cOperator < parseInt(divisor) ) {
                cDivident += '' + cChar;
            } else {
                cRest = cOperator % divisor;
                if ( cRest == 0 ) {
                    cRest = '';
                }
                cDivident = '';
            }

        }
        cRest += '' + cDivident;
        if (cRest == '') {
            cRest = 0;
        }
        return cRest;
    }

    const mod97 = function (val) {
        let total = val.split('').map(function (char) {
            // Convert special chars to numbers
            if (char === '+') {
                char = 36;
            } else if (char ==='*') {
                char = 37;
            }

            // Convert letters to number A = 10, ... Z = 35
            const number = char.charCodeAt(0) - 55;
            if (number >= 10) {
                return number;
            }

            return Number.parseInt(char);
        }).join('');

        return modulo(total, 97) == 1;
    };

    const refField = element.dataset.selectField;
    const country = $('[name=' + refField + ']').val();

    let regex = /^NL[0-9]{9}B[0-9]{2}$/;
    if (country === 'BE') {
        regex = /^BE0[0-9]{9}$/;
    }

    return this.optional(element) || (regex.test(value) && ((country === 'NL' && (mod11(value) || mod97(value))) || country === 'BE'));
}, 'Ongeldig BTW nummer');


/** ----------------------------------------
 Contact Form
 ---------------------------------------- */

const contactForm = $('#contact-form');
contactForm.validate($.extend(validation_options, {
    rules: {
        name: {
            required: true
        },
        company: {
            required: true,
        },
        mail: {
            required: true,
            laxEmail: true
        },
        question: {
            required: true
        },
        comment: {
            required: true
        }
    },
    submitHandler: function (form) {
        const $this = $(form);
        const LoadingButton = $this.find('button');
        LoadingButton.addClass('is-loading');

        $.ajax({
            url: contactForm.attr('action'),
            method: 'POST',
            data: contactForm.serialize()
        }).fail(function (res) {
            requestErrorHandling(res, $this);
            LoadingButton.removeClass('is-loading');
        }).done(function (res) {
            LoadingButton.removeClass('is-loading');
            contactForm[0].reset();

            analytics.trackContactForm();

            const successMessage = contactForm.data('successMessage');
            if (successMessage) {
                alert(successMessage);
            }
        });
    }
}));


/** ----------------------------------------
 Newsletter form
 ---------------------------------------- */

const newsletterForm = $('#newsletter-from');
newsletterForm.validate($.extend(validation_options, {
    rules: {
        name: {
            required: true,
        },
        company: {
            required: true,
        },
        email: {
            required: true,
            laxEmail: true
        },
    },
    submitHandler: function (form) {
        const $this = $(form);
        const LoadingButton = $this.find('button');
        LoadingButton.addClass('is-loading');
        $.ajax({
            url: newsletterForm.attr('action'),
            method: 'POST',
            data: newsletterForm.serialize()
        }).fail(function (res) {
            requestErrorHandling(res, $this);
            LoadingButton.removeClass('is-loading');
        }).done(function (res) {
            LoadingButton.removeClass('is-loading');
            newsletterForm[0].reset();
            alert('Bedankt');
        });
    }
}));


/** ----------------------------------------
 Login form
 ---------------------------------------- */

const loginForm = $('#login-form');
loginForm.validate($.extend(validation_options, {
    rules: {
        email: {
            required: true,
            laxEmail: true
        },
        password: {
            required: true,
        },

    },
    submitHandler: function (form, event) {
        event.preventDefault();
        const loginButtonImage = loginForm.find('#submit');
        loginButtonImage.addClass('is-loading');

        $.ajax({
            url: loginForm.attr('action'),
            method: 'POST',
            data: loginForm.serialize()
        }).fail(function (res) {
            loginButtonImage.removeClass('is-loading');

            const text = res.responseJSON?.message ?? 'De opgegeven combinatie van gebruikersnaam en wachtwoord zijn niet bij ons bekend.';

            $('.validation-errors')
                .html(text)
                .slideDown();

        }).done(function (res) {
            loginButtonImage.removeClass('is-loading');

            if (res.redirect) {
                window.location.href = res.redirect;
            }
        });
    }
}));

/** ----------------------------------------
 Register form
 ---------------------------------------- */

let registerForm = $('#register-form');
registerForm.validate($.extend(validation_options, {
    rules: {
        email: {
            laxEmail: true
        },
        password: {
            minlength: 10
        },
        zipcode: {
            zipcode: true
        },
        vat: {
            vat: true
        }
    },
    messages: {
        password: {
            minlength: "Het wachtwoord moet minimaal 10 tekens lang zijn."
        },
        zipcode: {
            zipcode: "Voer alstublieft een geldige postcode in."
        },
        vat: {
            vat: "Voer alstublieft een geldig BTW-nummer in."
        },
    },
    submitHandler: function (form) {
        const $this = $(form);
        const LoadingButton = $this.find('button');
        LoadingButton.addClass('is-loading');

        $.ajax({
            url: $this.attr('action'),
            method: 'POST',
            data: $this.serialize()
        }).fail(function (res) {
            requestErrorHandling(res, $this);
            LoadingButton.removeClass('is-loading');
        }).done(function (res) {
            LoadingButton.removeClass('is-loading');
            if (res.redirect) {
                location.href = res.redirect;
            }
        });
    }
}));

registerForm.find('[name=country]').on('change', function () {
    registerForm.validate().element("[name=zipcode]");
    registerForm.validate().element("[name=vat]");
    registerForm.validate().element("[name=billing_zipcode]");
});

registerForm.find('[data-slide]').on('change', function () {
    const target = $(this).data('slide');
    if ($(this).is(':checked')) {
        registerForm.find('[data-slide-target=' + target + ']').slideDown('fast');
        return false
    }
    registerForm.find('[data-slide-target=' + target + ']').slideUp('fast');
    return true
});


/** ----------------------------------------
 Password change form
 ---------------------------------------- */

const resetForm = $('#password-reset-form');
resetForm.validate($.extend(validation_options, {
    rules: {
        email: {
            laxEmail: true
        },
        old_password: {
            minlength: 10
        },
        password: {
            minlength: 10
        },
        password_confirmation: {
            minlength: 10,
            equalTo: '#password'
        },
    },
    submitHandler: function (form) {
        const $this = $(form);
        const LoadingButton = $this.find('button');
        LoadingButton.addClass('is-loading');

        $.ajax({
            url: $this.attr('action'),
            method: 'POST',
            data: $this.serialize()
        }).fail(function (res) {
            requestErrorHandling(res, $this);
            LoadingButton.removeClass('is-loading');
        }).done(function (res) {
            LoadingButton.removeClass('is-loading');
            if (res.redirect) {
                location.href = res.redirect;
            }
        });
    }
}));

/** ----------------------------------------
 Account edit form
 ---------------------------------------- */

const accountEditForm = $('#edit-account-form');
accountEditForm.validate($.extend(validation_options, {
    rules: {
        email: {
            laxEmail: true
        },
    },
    submitHandler: function (form) {
        const $this = $(form);
        const LoadingButton = $this.find('button');
        LoadingButton.addClass('is-loading');

        $.ajax({
            url: $this.attr('action'),
            method: 'POST',
            data: $this.serialize()
        }).fail(function (res) {
            requestErrorHandling(res, $this);
            LoadingButton.removeClass('is-loading');
        }).done(function (res) {
            LoadingButton.removeClass('is-loading');
            if (res.redirect) {
                location.href = res.redirect;
            } else {
                $('.account-edit').slideUp({
                    done: function (e) {
                        const email = $this.find('input[name=email]').val()
                        $('.account-view .account-email').html(email);
                        const firstname = $this.find('input[name=firstname]').val();
                        const lastname = $this.find('input[name=lastname]').val();

                        $('.account-view .account-name').html(firstname.concat(' ').concat(lastname));
                        $('.account-view').slideDown();
                    }
                })
            }
        });
    }
}));

$('.account-view a').on('click', function (e) {
    e.preventDefault();
    $(this).parent().slideUp({
        done: function (e) {
            $('.account-edit').slideDown();
        }
    })
});

const placeOrderForm = $('#place-order-form');
placeOrderForm.validate($.extend(validation_options, {
    rules: {
        'order-reference': {
            required: true,
            minlength: 1,
            // TODO add MAX length validation for order reference
        },
        'delivery-date': {
            required: true,
            minlength: 1
        },
    },
    submitHandler: function (form) {
        $('.input-error').hide();
        form.submit();
    },
}));



/** ----------------------------------------
 Contact Form Alt
 ---------------------------------------- */

const contactFormAlt = $('#contact-form-alt');
contactFormAlt.validate($.extend(validation_options, {
    rules: {
        name: {
            required: true
        },
        mail: {
            required: true,
            laxEmail: true
        },
        question: {
            required: true
        },
        comment: {
            required: true
        }
    },
    submitHandler: function (form) {
        const $this = $(form);
        const LoadingButton = $this.find('button');
        LoadingButton.addClass('is-loading');

        $.ajax({
            url: contactFormAlt.attr('action'),
            method: 'POST',
            data: contactFormAlt.serialize()
        }).fail(function (res) {
            requestErrorHandling(res, $this);
            LoadingButton.removeClass('is-loading');
        }).done(function (res) {
            LoadingButton.removeClass('is-loading');
            contactFormAlt[0].reset();

            analytics.trackContactSpecificQuestion();

            const successMessage = contactFormAlt.data('successMessage');
            if (successMessage) {
                alert(successMessage);
            }
        });
    },
}));
